"use strict";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TokenService = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _constants = require("./constants");
var _internals = require("./internals");
var _storage = require("./storage");
var _TokenService;
var TokenService = /*#__PURE__*/ function() {
    function TokenService() {
        _class_call_check(this, TokenService);
        var // TODO: remove when this is fixed: https://github.com/microsoft/TypeScript/issues/53305
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- false positive
        _TokenService;
        (0, _defineProperty2.default)(this, "oidcTokenStorage", new _storage.OidcTokenStorage());
        var _instance;
        (_instance = (_TokenService = TokenService).instance) !== null && _instance !== void 0 ? _instance : _TokenService.instance = this;
        // eslint-disable-next-line no-constructor-return -- needed for the singleton pattern
        return TokenService.instance;
    }
    _create_class(TokenService, [
        {
            key: "getAuthorizationToken",
            value: // TODO: This is kind of weird flow. customerId is not always known, but could be available inside cookies. Should we somehow provide a way to get userId from that?
            function getAuthorizationToken(customerId) {
                var _this = this;
                return _async_to_generator(function() {
                    var token, userId;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                token = null;
                                userId = typeof customerId === 'string' ? Number(customerId) : customerId;
                                if (!(userId !== _constants.NOT_LOGGED_IN_USER_ID)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.getTokenServiceUserToken()
                                ];
                            case 1:
                                token = _state.sent();
                                if (!token) {
                                    token = _this.getSessionStorageToken();
                                }
                                _state.label = 2;
                            case 2:
                                if (!!token) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _this.getTokenServicePublicToken()
                                ];
                            case 3:
                                token = _state.sent();
                                _state.label = 4;
                            case 4:
                                if (!token) {
                                    throw new Error('Token is missing!');
                                }
                                return [
                                    2,
                                    token
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSessionStorageToken",
            value: function getSessionStorageToken() {
                var token = this.oidcTokenStorage.getAccessToken();
                if (token) {
                    return token.toString();
                }
                return null;
            }
        },
        {
            key: "getTokenServiceUserToken",
            value: function getTokenServiceUserToken() {
                return _async_to_generator(function() {
                    var result, _result_Token;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    TokenService.userTokenClient.getToken()
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    (_result_Token = result === null || result === void 0 ? void 0 : result.Token) !== null && _result_Token !== void 0 ? _result_Token : null
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getTokenServicePublicToken",
            value: function getTokenServicePublicToken() {
                return _async_to_generator(function() {
                    var result, _result_Token;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    TokenService.publicTokenClient.getToken()
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    (_result_Token = result === null || result === void 0 ? void 0 : result.Token) !== null && _result_Token !== void 0 ? _result_Token : null
                                ];
                        }
                    });
                })();
            }
        }
    ], [
        {
            key: "getInstance",
            value: function getInstance() {
                return new this();
            }
        }
    ]);
    return TokenService;
}();
exports.TokenService = TokenService;
_TokenService = TokenService;
(0, _defineProperty2.default)(TokenService, "instance", void 0);
// Create token clients just once - no need to create them every time TokenService is created
(0, _defineProperty2.default)(TokenService, "userTokenClient", new _internals.UserTokenClient());
(0, _defineProperty2.default)(TokenService, "publicTokenClient", new _internals.PublicTokenClient()); //# sourceMappingURL=TokenService.js.map
